import { createApiActionType } from 'app/store/utils';

const apiType = createApiActionType('applicationConfig');

export const GET_OVERRIDE_CONFIG = apiType('GetOverrideConfig');
export const SET_OVERRIDE_CONFIG = apiType('SetOverrideConfig');
export const GET_PUBLIC_CONFIG = apiType('GetPublicConfig');
